import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import _isFunction from "lodash/isFunction";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable no-fallthrough */

/* eslint-disable default-case */
import React, { useState, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider, Global } from '@emotion/react';
import { ThemeModeProvider, useThemeMode } from './ThemeModeContext';
import { globalCss } from '../styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var ThemeInner = function ThemeInner(_ref) {
  var children = _ref.children,
      initGlobalStyles = _ref.initGlobalStyles,
      _ref$iconSets = _ref.iconSets,
      iconSets = _ref$iconSets === void 0 ? {} : _ref$iconSets,
      _ref$theme = _ref.theme,
      themeProp = _ref$theme === void 0 ? null : _ref$theme;

  var _useThemeMode = useThemeMode(),
      themeConfig = _useThemeMode.themeConfig;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      theme = _useState2[0],
      setTheme = _useState2[1];

  useLayoutEffect(function () {
    setTheme(function (prev) {
      return _objectSpread(_objectSpread(_objectSpread({}, prev), themeConfig), themeProp);
    });
    injectIconFonts(_objectSpread(_objectSpread({}, themeConfig), iconSets));
  }, [themeConfig, themeProp]);

  var injectIconFonts = function injectIconFonts(data) {
    var fontAwesome = data.fontAwesome,
        lineAwesome = data.lineAwesome,
        iconsMind = data.iconsMind;
    if (fontAwesome) import('../Icon/icon-sets/font-awesome/font-awesome.css');
    if (lineAwesome) import('../Icon/icon-sets/line-awesome/line-awesome.css');
    if (iconsMind) import('../Icon/icon-sets/iconsmind/iconsmind.css');
  };

  return theme && ___EmotionJSX(ThemeProvider, {
    theme: theme
  }, ___EmotionJSX(Global, {
    styles: globalCss(theme)
  }), _isFunction(initGlobalStyles) && theme && ___EmotionJSX(Global, {
    styles: initGlobalStyles(theme)
  }), children);
};

ThemeInner.propTypes = {
  children: PropTypes.node,
  initGlobalStyles: PropTypes.func,
  iconSets: PropTypes.object,
  theme: PropTypes.object
};

var Theme = function Theme(props) {
  return ___EmotionJSX(ThemeModeProvider, null, ___EmotionJSX(ThemeInner, props));
};

Theme.propTypes = {
  children: PropTypes.node,
  initGlobalStyles: PropTypes.func,
  iconSets: PropTypes.object,
  theme: PropTypes.object
};
export default Theme;